import {
  addAllPoints,
  adjustAllPassengers,
  adjustSeatClass,
} from '@/slices/area/slices/searchFlightFormSlice';
import { setSelectedDate } from '@/slices/calendar/calendarSlice';
import {
  removeFlight,
  removeReturnFlight,
} from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { style } from '@/styles/globals';
import { convertMoney } from '@/utils/convertMoney';
import { useAppDispatch } from '@/utils/hook';
import { getParamsFlightMapping } from '@/utils/paramsMapping';
import { pr } from '@/utils/pxToRem';
import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { styled } from '@mui/system';
import { uniqueId } from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';
import { TABLE_FARE } from './constants';
import WideTableCell from '../WideTableCell';
import FlexTableRow from '../FlexTableRow';
import ShowNoDataDescription from '../ShowNoDataDescription';
import { StyledTableRow } from '../StyledTableRow';
import { setFilterFlight } from '@/slices/filterFlight/filterFlightSlice';

const CTABooking = styled('div')`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: ${style.color.product3};
  font-weight: 700;
  cursor: pointer;
`;

export default function TableFare({ isDesktop, companyType }: { isDesktop?: boolean, companyType: any }) {
  const dispatch = useAppDispatch();
  const data = TABLE_FARE;
  const router = useRouter();
  // const data = flightData ? flightData[date] : [];
  const onSelectTrip = (row: any) => {
    const tmpStartPoint = row.fromData;
    const tmpToPoint = row.toData;
    const tmpSelectedDate = {
      depart: new Date().toDateString(),
      return: null,
    };

    const tmpPassenger = {
      adt: 1,
      chd: 0,
      inf: 0,
    };
    const tmpSeatClass = 'PT';
    if (
      !tmpStartPoint
      || !tmpToPoint
      || !tmpSelectedDate
      || !tmpPassenger
      || !tmpSeatClass
    ) {
      return;
    }

    dispatch(removeFlight());
    dispatch(removeReturnFlight());

    dispatch(
      addAllPoints([
        {
          data: tmpStartPoint,
          type: 'from',
        },
        {
          data: tmpToPoint,
          type: 'to',
        },
      ]),
    );
    dispatch(setSelectedDate({ dateObj: JSON.stringify(tmpSelectedDate) }));
    dispatch(adjustAllPassengers(tmpPassenger));
    dispatch(adjustSeatClass({ seatClass: tmpSeatClass }));
    dispatch(setFilterFlight({ airline: [companyType] }));

    const path = getParamsFlightMapping({
      tmpPassenger,
      tmpSeatClass,
      tmpSelectedDate,
      tmpToPoint,
      tmpStartPoint,
    });
    router.push(path);
  };
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        border: '1px solid #E8EDF1',
        boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
        borderRadius: '3px',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{ background: 'white' }}>
            <WideTableCell align="center">Tuyến đường</WideTableCell>
            {isDesktop ? (
              <>
                <WideTableCell align="center">
                  Số chuyến
                </WideTableCell>
                <WideTableCell align="center">
                  Giá rẻ nhất
                </WideTableCell>

              </>

            ) : (

              <WideTableCell align="center">
                Số chuyến & giá rẻ nhất
              </WideTableCell>

            ) }
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {data ? (
            data.slice(0, 2)?.map((row: any) => (
              <StyledTableRow
                key={uniqueId()}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <WideTableCell align="center">{`${row.from_name} - ${row.to_name}`}</WideTableCell>
                <WideTableCell align="center">
                  <div>
                    {row.available_trip}
                    {' '}
                    chuyến
                  </div>
                  {!isDesktop

                    && convertMoney(row.min_price)}
                </WideTableCell>
                {isDesktop && (
                <WideTableCell align="center">

                  {convertMoney(row.min_price)}
                </WideTableCell>

                )}
                <WideTableCell align="center">
                  <CTABooking onClick={() => onSelectTrip(row)}>
                    Đặt vé
                  </CTABooking>
                </WideTableCell>
              </StyledTableRow>
            ))
          ) : (
            <Box sx={{ p: pr`16px` }}>
              <ShowNoDataDescription />
            </Box>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
